import script from "./EduPage.vue?vue&type=script&setup=true&lang=js"
export * from "./EduPage.vue?vue&type=script&setup=true&lang=js"

import "./EduPage.vue?vue&type=style&index=0&id=346f2e61&lang=scss&scoped=true"

import exportComponent from "../../../../node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['__scopeId',"data-v-346f2e61"]])

export default __exports__